module.exports = __webpack_public_path__ + "static/media/XXIe.9f9680e2.png";